export const BENCHMARKS_CHART_COLORS = {
  category: {
    primary: '#4369F4',
    secondary: '#C6CEEC',
    tertiary: '#85E0DF',
    quaternary: '#00A6A4',
    quinary: '#9283E2',
  },
  brand: {
    primary: '#00A6A4',
    secondary: '#AEEAEA',
  },
};

export const BENCHMARKS_CHART_LABELS_STRUCTURE = {
  category: Object.keys(BENCHMARKS_CHART_COLORS['category']),
  brand: Object.keys(BENCHMARKS_CHART_COLORS['brand']),
};

export const BENCHMARKS_TABS = {
  category: { name: 'Category Benchmarks', routeName: 'benchmarks-category-base' },
  brand: { name: 'Brand Benchmarks', routeName: 'benchmarks-brand-base' },
};

const BASE_SORT = {
  sortKey: 'base',
  sortOrder: 1,
};
const CATEGORY_SORT = {
  sortKey: 'category',
  sortOrder: 1,
};

export const benchmarksCards = [
  {
    value: 'platformType',
    key: 'Platform',
    title: 'Platform Purchase Intent Rate',
    reportTitle: 'Platform',
    categorySorting: { ...CATEGORY_SORT },
    brandSorting: { ...BASE_SORT },
  },
  {
    value: 'retailer',
    key: 'Retailer',
    title: 'Retailer Purchase Intent Rate',
    reportTitle: 'Retailer',
    categorySorting: { ...CATEGORY_SORT },
    brandSorting: { ...BASE_SORT },
  },
  {
    value: 'trafficType',
    key: 'Traffic',
    title: 'Traffic Type Purchase Intent Rate',
    reportTitle: 'TrafficType',
    categorySorting: { ...CATEGORY_SORT },
    brandSorting: { ...BASE_SORT },
  },
  {
    value: 'campaignObjectiveType',
    key: 'Objective',
    title: 'Campaign Objective Purchase Intent Rate',
    reportTitle: 'CampaignObjective',
    categorySorting: { ...CATEGORY_SORT },
    brandSorting: { ...BASE_SORT },
  },
];

export const benchmarksTitles = benchmarksCards.map(c => c.title);

export const benchmarksValues = benchmarksCards.map(c => c.value);
